import { render, staticRenderFns } from "./imageComponent.vue?vue&type=template&id=6954537c&scoped=true"
import script from "./imageComponent.vue?vue&type=script&lang=js"
export * from "./imageComponent.vue?vue&type=script&lang=js"
import style0 from "./imageComponent.vue?vue&type=style&index=0&id=6954537c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6954537c",
  null
  
)

export default component.exports